module.exports = __webpack_public_path__ + "static/media/alarm-clock.e2725e33.svg";